<script setup lang="ts">
import { ref } from 'vue';
import { type Afiliado } from '../types';

const props = defineProps<{
    afiliado: Afiliado;
    apiPdfUrl: String;
    requestToken: String;
    downloadText: String;
}>();
const baseImgPath = import.meta.env.VITE_IMG_PATH;
const apiPdfUrl = props.apiPdfUrl!.toString();
const dataTextArea = `<textarea name="data" style="display: none">${JSON.stringify(props.afiliado)}</textarea>`;
</script>

<template>
    <form :action="apiPdfUrl" method="post">
        <input type="hidden" name="__RequestVerificationToken" :value="props.requestToken" />
        <input type="hidden" name="encodeRequest" value="false" />

        <div :class="'card-credencial ' + (props.afiliado.organizacion === 'APSOT' ? 'blue' : 'green')">
            <div class="logo-card">
                <img :src="baseImgPath + '/layout/logo/logo-white.svg'" alt="logo Apsot" />
                <p>{{ props.afiliado.planCredencial }}</p>
            </div>
            <p class="name-credencial">{{ props.afiliado.nombreApellido }}</p>
            <div class="data-credencial">
                <div class="number-card">
                    <p class="number-credencial">{{ props.afiliado.nroCredencial }}</p>
                    <p class="number-label">N° de beneficiario</p>
                </div>
            </div>
        </div>

        <span v-html="dataTextArea"></span>
        <button type="submit" class="bttn pink"><i class="icon-download"></i>{{ props.downloadText }}</button>
    </form>
</template>
